import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { DriverService } from '@core/services/driver.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidator, emailOrPhoneValidator, passwordValidator } from '../../services/custom-validatior.abstract';
import { CONFIRM_PASSWORD_MATCH_MESSAGE, PASSCODE_ENTER_MSG, RESNET_PASSWPRD_MSG, UPD_PASSWORD_MSG } from '../../constant/shared.constant';
import { ToastService } from '../../services/toast.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  otpEmail: string;
  countDown: string = '1:00';
  resendOtp: boolean = false;
  showButton: boolean = false;
  email: string;
  count: number = 0;
  firstDiv: boolean = true;
  secondDiv: boolean = false;
  thirdDiv: boolean = false;
  resetForm: FormGroup;
  otp: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };

constructor(private readonly service: DriverService, 
    private readonly ref: DynamicDialogRef,
    private readonly formBuilder: FormBuilder,
    private readonly toastService: ToastService,) {
  }
  ngOnInit() {
    
    this.resetForm = this.formBuilder.group({
      otpEmail: ['', [Validators.required, emailOrPhoneValidator]],
      newPassword: ['', [Validators.required, Validators.minLength(8), passwordValidator]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8), passwordValidator]],
    });
  }

  isEmailId(value: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  }

  sendOtp() {
    if (this.resetForm.get('otpEmail').valid) {
      if (this.resetForm.get('otpEmail').value.trim() === '') {
        this.resetForm.get('otpEmail').setErrors({ 'required': true, 'pattern': true });
        return;
      }
      
      this.email = this.resetForm.value.otpEmail;
      this.showButton = false;
      this.startCountDown();
      const isEmail = this.email.includes('@');
      const req: any = {
        verificationFor: 0,
        email: isEmail ? this.email : null,
        mobileNumber: isEmail ? null : this.email,
        requestCount: this.count + 1,
      };

      this.service.sendOtpForVerification(req)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (_res) => {

          if (_res) {
            
            if (!this.resendOtp) {
              this.secondDiv = true;
              this.firstDiv = false;
              this.toastService.showToastMessage('success', 'Success', _res.message);
              
            } else {
              this.toastService.showToastMessage('success', 'Success', RESNET_PASSWPRD_MSG);
            }
          }
        },
        error: (er: HttpErrorResponse) => {
          this.toastService.showToastMessage('error', 'Error', er.error.message);
          
        }

      });
    }
    else {
      CustomValidator.markFormGroupTouched(this.resetForm['otpEmail']);
    }
  }

  checkPassword() {
    if (!this.resetForm.valid) {
      CustomValidator.markFormGroupTouched(this.resetForm);
      return;
    }
  
    const { newPassword, confirmPassword } = this.resetForm.value;
  
    if (newPassword !== confirmPassword) {
      this.toastService.showToastMessage('error', 'Error', CONFIRM_PASSWORD_MATCH_MESSAGE);
      return;
    }
  
    this.verifyEmailByOTP();
  }

  onClickSendOtp(event) {
    event.preventDefault();
    this.sendOtp();
    this.resendOtp = true;
  }
  onOtpChange(otp) {
    this.otp = otp;
  }

  verifyEmailByOTP() {
    if (this.otp?.length >= 6) {
      
      const email = this.resetForm.value.otpEmail
      const isEmail = email.includes('@');
      const req: any = {
        email: isEmail ? email : null,
        mobileNumber: isEmail ? null : email,
        requestFrom: 3,
        newPassword: this.resetForm.value?.newPassword,
        otp : this.otp
      };

      this.service.verifyEmailByOTP(req)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (_res) => {

          if (_res.message) {
            this.secondDiv = false;
            this.thirdDiv = true;
            
            this.toastService.showToastMessage('success', 'Success', _res.message);
            if (_res.message == UPD_PASSWORD_MSG) {
              setTimeout(() => {
                this.ref.close();
              }, 1000);

            }
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error) {
            
            if (error.error.message === 'Please send Passcode') {
              this.toastService.showToastMessage('error', 'Error', PASSCODE_ENTER_MSG);
            } else {
              this.toastService.showToastMessage('error', 'Error', error.error.message);
            }
          }
        }
      });
    }
    else {
      this.toastService.showToastMessage('error', 'Error', PASSCODE_ENTER_MSG)
    }
  }

  check() {
    this.ref.close();
  }
  startCountDown() {
    let countDownDate = new Date();
    countDownDate.setMinutes(countDownDate.getMinutes() + 1);
    let countDownInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countDownDate.getTime() - now;
      let minutes = Math.floor(distance / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.countDown = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      if (distance <= 0) {
        clearInterval(countDownInterval);
        this.countDown = '0:00';
        this.showButton = true;
      }
    }, 1000);
  }
}
